import { Outlet } from "react-router";

// Top-level layout shell. Section layouts (admin/portal/embed) nest inside.
// Kept intentionally bare in Phase 1 — top nav and side nav land in Phase 3
// once the auth context is wired end-to-end.
export function RootLayout() {
  return (
    <div className="min-h-full">
      <Outlet />
    </div>
  );
}
